// src/constants/BlogsContent.js
export const aboutUs = [
  {
    photo: `${process.env.REACT_APP_CLIENT_URL}/images/blogs/visa-b.jpg`,
    title: "لماذا تختار طبيبي؟",
    description: [
      "✔️ سهولة الوصول: جميع الخدمات الطبية والمعلومات التي تحتاجها في مكان واحد.",
      "✔️ تقنيات حديثة: نعتمد على الذكاء الاصطناعي والتكنولوجيا لتوفير تجربة فريدة.",
      "✔️ أطباء مؤهلون: قاعدة بيانات شاملة لأفضل الأطباء والخبراء.",
      "✔️ دعم مستمر: فريق دعم متاح لمساعدتك في أي وقت.",
    ],
  },
  {
    photo: `${process.env.REACT_APP_CLIENT_URL}/images/team/amine.jpeg`,
    name: "Amine MAALEM",
    job: "PDG et fondateur",
    jobAr: "الرئيس التنفيذي والمؤسس",
    description:
      "Fondateur, PDG et directeur de l'équipe de développement et des chercheurs",
    link: "#",
  },
  {
    photo: `${process.env.REACT_APP_CLIENT_URL}/images/team/meriem.jpg`,
    name: "Meriem MAALEM",
    job: "Directrice des relations publiques",
    jobAr: " مديرة العلاقات العامة",
    description:
      "Médecin généraliste senior, Plus de 25 ans dans le secteur public, Posséde et gère sa propre clinique",
  },
  {
    photo: `${process.env.REACT_APP_CLIENT_URL}/images/team/akim.png`,
    name: "Hakim Kerrache",
    job: "Directeur Central de Recherche et Développement",
    jobAr: " المدير المركزي للبحث والتطوير",
    description:
      "Ingénieur programmation et développement, PDG et fondateur de G-COSMOS WEB, Développeur full stack",
    link: "#",
  },
];
